export default __webpack_public_path__ + "static/media/benneyL2026.ba745674.PNG";